import { Axios, setAuthToken } from '@/api/Axios';
import { SearchType, FindShowTabType, LocalStorageConfig } from "@/components/AppConstants";
import { StoreApi } from '@/api/Api';
import { ShopConfig } from '@/store/Constraints'


const InitShopCount = 5;
const SeeMoreOffet = 10;

const ShopStore = {
    //namespaced: true,
    state: {
        currentView: FindShowTabType.Near,
        searchText: "",
        showLoading: false,
        storeList: {
            ShopSearch: [],
            ShopNear: [],
            ShopMy: []
        },
        currentShopCount: {
            ShopSearch: 0,
            ShopNear: 0,
            ShopMy: 0
        },
        totalShopCount: {
            ShopSearch: 0,
            ShopNear: 0,
            ShopMy: 0
        },
    },
    getters: {
        [ShopConfig.CURRENT_VIEW]: (state) => state.currentView,
        [ShopConfig.STORE_LIST]: (state) => (view) => state.storeList[view],
        [ShopConfig.SEARCH_TEXT]: (state) => state.searchText,
        [ShopConfig.SHOW_LOADING]: (state) => state.showLoading,
        [ShopConfig.TOTAL_SHOP_COUNT]: (state) => state.totalShopCount
    },
    mutations: {
        [ShopConfig.SHOP_SEARCH_FORM]: (state) => {
            localStorage.setItem(LocalStorageConfig.FindShopTab, FindShowTabType.Search);
            state.currentView = FindShowTabType.Search;
        },
        [ShopConfig.SHOP_NEAR_FORM]: (state) => {
            localStorage.setItem(LocalStorageConfig.FindShopTab, FindShowTabType.Near);
            state.currentView = FindShowTabType.Near;
        },
        [ShopConfig.SHOP_MY_FORM]: (state) => {
            localStorage.setItem(LocalStorageConfig.FindShopTab, FindShowTabType.My);
            state.currentView = FindShowTabType.My;
        },
        [ShopConfig.FETCH_SHOP_LIST]: (state, payload) => {
            state.storeList[payload.key] = payload.storeList;
            state.currentShopCount[payload.key] = payload.storeList.length;
            state.totalShopCount[payload.key] = payload.totalCount;
        },
        [ShopConfig.INIT_SHOP_LIST]: (state, payload) => {
            state.storeList[payload.view] = [];
            state.currentShopCount[payload.view] = 0;
            state.totalShopCount[payload.view] = 0;
            if (payload.view === FindShowTabType.Search) {
                state.searchText = "";
            }
        },
        [ShopConfig.INIT_SHOP_ALL]: (state) => {
            for (let key in state.storeList) {
                state.storeList[key] = [];
            }
            for (let key in state.currentShopCount) {
                state.currentShopCount[key] = 0;
            }
            for (let key in state.totalShopCount) {
                state.totalShopCount[key] = 0;
            }
            state.searchText = "";
            state.currentView = FindShowTabType.Near;
        },
        [ShopConfig.SHOW_LOADING]: (state, payload) => {
            state.showLoading = payload.showLoading;
        }
    },
    actions: {
        [ShopConfig.SHOP_SEARCH_FORM]: (store) => {
            store.commit(ShopConfig.SHOP_SEARCH_FORM);
        },
        [ShopConfig.SHOP_NEAR_FORM]: (store) => {
            store.commit(ShopConfig.SHOP_NEAR_FORM);
        },
        [ShopConfig.SHOP_MY_FORM]: (store) => {
            store.commit(ShopConfig.SHOP_MY_FORM);
        },
        [ShopConfig.INIT_SHOP_LIST]: (store, payload) => {
            store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
            store.commit(ShopConfig.INIT_SHOP_LIST, payload.view);

            if (payload.view === FindShowTabType.Search) {
                if (store.state.searchText.trim().length === 0) {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    return;
                }

                var params = {
                    searchType: SearchType.All,
                    lat: '35.247069', // api 수정되면 삭제
                    lng: '127.863377', // api 수정되면 삭제
                    searchKeyword: store.state.searchText,
                    page: 0,
                    size: store.state.currentShopCount[payload.view]
                };
            } else if (payload.view === FindShowTabType.Near) {
                if (!payload.lat || !payload.lng) {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    return;
                }

                var params = {
                    searchType: SearchType.All,
                    lat: payload.lat,
                    lng: payload.lng,
                    searchKeyword: '',
                    page: 0,
                    size: store.state.currentShopCount[payload.view] === 0 ? InitShopCount : store.state.currentShopCount[payload.view]
                }
            } else {
                return;
            }

            Axios.get(StoreApi.GET_STORE_LIST, params)
                .then((response) => {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    if (response.code == "0000") {
                        console.log("FETCH_SHOP_SEARCH", response.data);
                        store.commit(ShopConfig.FETCH_SHOP_LIST, {
                            storeList: response.data.storeList,
                            totalCount: response.data.totalCnt,
                            key: payload.view
                        });
                    }
                })
                .catch((error) => {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    store.commit(ShopConfig.INIT_SHOP_LIST, payload.view);
                    console.error('ShopSearch.methods.requestStoreList ->', error);
                })
        },
        [ShopConfig.FETCH_SHOP_SEARCH]: (store, payload) => {
            store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
            store.state.searchText = payload.text;

            if (store.state.searchText.trim().length === 0) {
                store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                store.commit(ShopConfig.INIT_SHOP_LIST, FindShowTabType.Search);
            } else {
                let params = {
                    searchType: SearchType.All,
                    lat: '35.247069', // api 수정되면 삭제
                    lng: '127.863377', // api 수정되면 삭제
                    searchKeyword: store.state.searchText,
                    page: 0,
                    size: payload.more && store.state.currentShopCount[FindShowTabType.Search] !== 0 ? 
                            store.state.currentShopCount[FindShowTabType.Search] + SeeMoreOffet : InitShopCount
                };

                Axios.get(StoreApi.GET_STORE_LIST, params)
                    .then((response) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        if (response.code == "0000") {
                            console.log("FETCH_SHOP_SEARCH", response.data);
                            store.commit(ShopConfig.FETCH_SHOP_LIST, {
                                storeList: response.data.storeList,
                                totalCount: response.data.totalCnt,
                                key: FindShowTabType.Search
                            });
                        }
                    })
                    .catch((error) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        store.commit(ShopConfig.INIT_SHOP_LIST, FindShowTabType.Search);
                        console.error('ShopSearch.methods.requestStoreList ->', error);
                    })
            }
        },
        [ShopConfig.FETCH_SHOP_NEAR]: (store, payload) => {
            store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
            let params = {
                searchType: SearchType.All,
                lat: payload.lat,
                lng: payload.lng,
                searchKeyword: '',
                page: 0,
                size: store.state.currentShopCount[FindShowTabType.Near] === 0 ? 
                        InitShopCount : store.state.currentShopCount[FindShowTabType.Near] + SeeMoreOffet
            }

            Axios.get(StoreApi.GET_STORE_LIST, params)
                .then((response) => {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    if (response.code == "0000") {
                        console.log("FETCH_SHOP_NEAR", response.data);
                        store.commit(ShopConfig.FETCH_SHOP_LIST, {
                            storeList: response.data.storeList,
                            totalCount: response.data.totalCnt,
                            key: FindShowTabType.Near
                        });
                    }
                })
                .catch((error) => {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    store.commit(ShopConfig.INIT_SHOP_LIST, FindShowTabType.Near);
                    console.error('ShopNear.methods.requestStoreList ->', error);
                })
        },
        [ShopConfig.FETCH_SHOP_MY]: (store, payload) => {
            store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
            let params = { searchType: SearchType.All };

            Axios.get(StoreApi.GET_STORE_FAVORITE_LIST, params)
                .then((response) => {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    if (response.code == "0000") {
                        console.log("FETCH_SHOP_MY", response.data);
                        store.commit(ShopConfig.FETCH_SHOP_LIST, {
                            storeList: response.data.storeList,
                            totalCount: response.data.totalCnt,
                            key: FindShowTabType.My
                        });
                    }
                })
                .catch((error) => {
                    store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                    store.commit(ShopConfig.INIT_SHOP_LIST, FindShowTabType.My);
                    console.error('ShopMy.methods.requestStoreList ->', error);
                })
        },
        [ShopConfig.FETCH_SHOP_DETAIL]: (store, payload) => {
            return new Promise((resolve, reject) => {
                store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
                let params = { storeCode: payload.storeCode };

                Axios.get(StoreApi.GET_STORE_DETAIL, params)
                    .then((response) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        if (response.code == "0000") {
                            console.log("FETCH_SHOP_DETAIL", response.data);
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        console.error('ShopDetail.methods.requestStoreDetail ->', error);
                        reject(error);
                    })
            });
        },
        [ShopConfig.ADD_FAVORITE_STORE]: (store, payload) => {
            return new Promise((resolve, reject) => {
                store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
                let params = { storeCode: payload.storeCode };
                console.log(params)

                Axios.post(StoreApi.ADD_FAVORITE_STORE, params)
                    .then((response) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        if (response.code == "0000") {
                            console.log("ADD_FAVORITE_STORE", response.data);
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        console.error(error);
                        reject(error);
                    })
            });
        },
        [ShopConfig.DELETE_FAVORITE_STORE]: (store, payload) => {
            return new Promise((resolve, reject) => {
                store.commit(ShopConfig.SHOW_LOADING, { showLoading: true });
                let params = { myStoreId: payload.myStoreId };

                Axios.post(StoreApi.DELETE_FAVORITE_STORE, params)
                    .then((response) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        if (response.code == "0000") {
                            console.log("DELETE_FAVORITE_STORE", response.data);
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        store.commit(ShopConfig.SHOW_LOADING, { showLoading: false });
                        console.error(error);
                        reject(error);
                    })
            });
        }
    }
}
export default ShopStore;


// WEBPACK FOOTER //
// ./src/store/shop/ShopStore.js